var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDiscord = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "discord@2x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.0\\u6539\\u7248",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pool_\\u79FB\\u9664\\u6D41\\u52A8\\u6027_\\u9AD8\\u7EA7\\u6A21\\u5F0F",
    transform: "translate(-628.000000, -1202.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(580.000000, 1171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-25",
    transform: "translate(0.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discord",
    transform: "translate(48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.37096774,0 0,5.37096774 0,12 C0,18.6290323 5.37096774,24 12,24 C18.6290323,24 24,18.6290323 24,12 C24,5.37096774 18.6290323,0 12,0 Z",
    id: "\\u5F62\\u72B6",
    fill: "#7569E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5535212,7.08874706 C16.5178126,6.58012488 15.410384,6.21047943 14.2525978,6 C14.1104077,6.26982713 13.944289,6.63275049 13.8297562,6.9214547 C12.5989997,6.72718193 11.3795605,6.72718193 10.1714385,6.9214547 C10.0569276,6.63275049 9.8870365,6.26982713 9.74357436,6 C8.58453794,6.21047943 7.4758372,6.58148311 6.44012866,7.0914405 C4.3510952,10.4048514 3.78479257,13.6359628 4.06794443,16.8211937 C5.45350124,17.9072243 6.79627273,18.5669552 8.1163833,18.9986648 C8.44232596,18.5278198 8.73302269,18.0273009 8.98345089,17.4998017 C8.5065012,17.3095805 8.04968579,17.0748371 7.61804918,16.8023166 C7.73256009,16.713272 7.84457067,16.6201758 7.95278688,16.5243861 C10.5854631,17.8168445 13.445933,17.8168445 16.0471577,16.5243861 C16.156646,16.6201758 16.2686346,16.713272 16.3818954,16.8023166 C15.9489867,17.0761724 15.4909211,17.3109158 15.0139714,17.5011599 C15.2643996,18.0273009 15.5538461,18.529178 15.881039,19 C17.2024216,18.5682904 18.546439,17.9085825 19.9319968,16.8211937 C20.2642342,13.1286988 19.364443,9.92726126 17.5535212,7.08874706 Z M9.34211722,14.8623054 C8.55181427,14.8623054 7.90370137,14.0879077 7.90370137,13.1448825 C7.90370137,12.2018572 8.5379747,11.4261244 9.34211722,11.4261244 C10.1462817,11.4261244 10.7943726,12.200499 10.7805331,13.1448825 C10.7817832,14.0879077 10.1462817,14.8623054 9.34211722,14.8623054 Z M14.6578273,14.8623054 C13.8675244,14.8623054 13.2194115,14.0879077 13.2194115,13.1448825 C13.2194115,12.2018572 13.8536629,11.4261244 14.6578273,11.4261244 C15.4619699,11.4261244 16.1100828,12.200499 16.0962432,13.1448825 C16.0962432,14.0879077 15.4619699,14.8623054 14.6578273,14.8623054 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  }))))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiscord, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/discord.88bbbae2.svg";
export { ForwardRef as ReactComponent };